<template>
  <div class="access-management gray-6 bg">
    <nav-bar />
    <div class="content">
      <side-nav />
      <md-app class="profile gray-3 bg">
        <md-app-drawer class="gray-3 bg" md-permanent="clipped">
          <md-list v-if="!isInSubRoute()" class="gray-3 bg drawer-menu">
            <md-list-item to="/access/organizations">
              <span class="md-list-item-text">Organizations</span>
            </md-list-item>

            <md-list-item to="/access/users">
              <span class="md-list-item-text">Users</span>
            </md-list-item>

            <md-list-item to="/access/cases">
              <span class="md-list-item-text">Cases</span>
            </md-list-item>

            <md-list-item to="/access/skeleton">
              <span class="md-list-item-text">Skeleton Key</span>
            </md-list-item>

            <md-list-item to="/access/templates">
              <span class="md-list-item-text">Templates</span>
            </md-list-item>

            <md-list-item to="/access/notifications">
              <span class="md-list-item-text">Notifications</span>
            </md-list-item>
          </md-list>
          <div v-else class="md-display-1 go-back-button" @click="goBack()">
            <md-icon>arrow_back</md-icon>
            <span class="label">Go Back</span>
          </div>
        </md-app-drawer>

        <md-app-content class="gray-3 bg">
          <router-view />
        </md-app-content>
      </md-app>
    </div>
  </div>
</template>

<script>
import auth from '../../../lib/common/providers/auth';

import SideNav from '../../../lib/common/components/SideNav';
import NavBar from '../../../lib/common/components/NavBar';

export default {
  name: 'access-management',
  components: {
    SideNav,
    NavBar
  },
  async created() {
    if (!(await auth.isAuthenticated())) {
      this.$router.push({ name: 'login' });
    }
  },
  methods: {
    isInSubRoute() {
      const topLevelRoutes = ['organizations', 'users', 'cases', 'skeleton', 'templates', 'notifications'];
      return !topLevelRoutes.includes(this.$router.currentRoute.name);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.access-management {
  display: flex;
  flex-direction: column;
}
.content {
  flex: 1;
  height: calc(100% - 88px);
}
.md-app {
  height: 100%;
}

.md-app-drawer {
  width: 200px;
  padding-top: 40px;
}

.md-app >>> .md-app-scroller {
  height: 100%;
}

.drawer-menu .md-list-item-text {
  align-items: flex-end;
}

.md-app-content {
  padding-top: 40px;
}

.go-back-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.go-back-button .label {
  font-size: 24px;
  font-weight: bold;
}

.go-back-button .md-icon {
  font-size: 45px !important;
  margin-bottom: 12px;
}
</style>
